import Airtable from "airtable";
import { plainToInstance } from "class-transformer";
import { Area } from "../entities/area";

const baseId = process.env.REACT_APP_AIR_TABLE_BASE;
const areaTableId = process.env.REACT_APP_AIR_TABLE_AREA_TABLE;

// The Airtable Personal Access Token is intentionally NOT read on the client.
// All requests go through a same-origin reverse proxy (nginx in production,
// setupProxy.js in local dev) that injects the `Authorization: Bearer <token>`
// header server-side, so the token never reaches the browser bundle or the
// network tab. Only the (non-secret) base id and table id ship to the client.
const AIRTABLE_PROXY_ENDPOINT = `${window.location.origin}/airtable`;

const hasValidConfig = Boolean(baseId && areaTableId);

const areaTable = hasValidConfig
  ? new Airtable({
      // Dummy key — the proxy overwrites the Authorization header with the real token.
      apiKey: "proxy",
      endpointUrl: AIRTABLE_PROXY_ENDPOINT,
    })
      .base(baseId as string)(areaTableId as string)
  : null;

const SOLD_OUT_STATE_VALUES = ["일시만실", "만실"];
const REGION_AGNOSTIC_LABEL = "지역 무관";

export function isSoldOutState(state?: string | null) {
  const normalized = (state ?? "").replace(/\s/g, "");
  return SOLD_OUT_STATE_VALUES.includes(normalized);
}

export async function getAreaListFromAirtable(): Promise<Area[]> {
  if (!areaTable) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        "[airtable] Missing Airtable configuration. Please set REACT_APP_AIR_TABLE_* env variables."
      );
    }
    return [];
  }

  try {
    const response = await areaTable
      .select({
        sort: [{ field: "정렬순서(SO)", direction: "asc" }],
      })
      .all();

    return response
      .filter((area) => {
        const fields = area.fields as Record<string, unknown>;
        const areaName = (fields["지역(SO)"] ?? "") as string;
        return areaName !== "" && areaName !== REGION_AGNOSTIC_LABEL;
      })
      .map((area) => plainToInstance(Area, area.fields));
  } catch (error) {
    console.error("[airtable] Failed to load area list", error);
    return [];
  }
}

export type { Area };
